import React from 'react';
import { Bar } from 'react-chartjs-2';

export default class App extends React.Component {

    state = {}

    componentDidMount() {
        this.getLastMonths(5);
    }

    getLastMonths(month) {
        let context = this;
        let lastSiXMonthsByName = this.lastSiXMonthsByName(month);
        let lastSixMonthByNumber = this.lastSixMonthByNumber(lastSiXMonthsByName);
    }

    lastSixMonthByNumber(months) {
        var monthNames = [
            { monthName: "January", monthNumber: '01' }, 
            { monthName: "February", monthNumber: '02' }, 
            { monthName: "March", monthNumber: '03' }, 
            { monthName: "April", monthNumber: '04' }, 
            { monthName: "May", monthNumber: '05' }, 
            { monthName: "June", monthNumber: '06' }, 
            { monthName: "July", monthNumber: '07' }, 
            { monthName: "August", monthNumber: '08' }, 
            { monthName: "September", monthNumber: '09' }, 
            { monthName: "October", monthNumber: '10' }, 
            { monthName: "November", monthNumber: '11' }, 
            { monthName: "December", monthNumber: '12' }, 
        ];
        let monthByNumber = [];
        months.map((c) => {
            monthNames.map((v) => {
                if (c == v.monthName) {
                    monthByNumber.push(v.monthNumber);
                }
            })
        })
    }

    lastSiXMonthsByName(lastmonth) {
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var today = new Date();
        var d;
        var month;
        let months = [];
        for(var i = lastmonth; i >= 0; i -= 1) {
            d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            month = monthNames[d.getMonth()];
            months.push(month);
        }
        return months;
    }

    getbranchs() {
        let branch = [];
        this.props.branch.map((c) => {
            branch.push(c.name);
        })
        let data = {
            labels: branch,
            datasets: [
            ]
        }
    }

    options() {
        const options = {
            scales: {
                yAxes: [
                    {
                        stacked: true,
                        ticks: {
                        beginAtZero: true,
                        },
                    },
                ],
                xAxes: [
                    {
                        stacked: true,
                    },
                ],
            },
        };
        return options;
    }

  render() {
    let data = this.getbranchs();
    let options = this.options();
    return (
      <div>
        <Bar data={data} options={options} />
      </div>
    );
  }

}